import { render, staticRenderFns } from "./CustomersServiceDetails.vue?vue&type=template&id=00f0c0d6&scoped=true&"
import script from "./CustomersServiceDetails.vue?vue&type=script&lang=js&"
export * from "./CustomersServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomersServiceDetails.vue?vue&type=style&index=0&id=00f0c0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0c0d6",
  null
  
)

export default component.exports